// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3w-Ml","inner":"Footer_inner__31exE","nextIcon":"Footer_nextIcon__1sqd-","innerLeft":"Footer_innerLeft__sWuiN"};